import React, { FC } from 'react';
import './styles.scss';
import { TMosaicGalleryProps } from './types/mediaMosaicItem.type';
import Breakpoints from '../../../../../constants/breakpoints.constants';
import useMediaQuery from '../../../../../hooks/useMediaQuery';
import Icon from '../../../icon';
import Picture from '../../../picture';

const MediaMosaicItem: FC<TMosaicGalleryProps> = ({ media }: TMosaicGalleryProps) => {
  const isWide = useMediaQuery(`(min-width: ${Breakpoints['tbl-p']}px)`);

  return (
    <div className={'mosaic-tile'}>
      {media.isVideo && (
        <div className="mosaic-tile__video">
          <Icon iconName={'action-play'} color={'white'} size={isWide ? 40 : 24} />
        </div>
      )}
      <Picture
        editorialImageProps={
          media.editorialImageProps && {
            ...media.editorialImageProps,
            isVideoThumbnail: media.isVideo,
            cssClassPictureEl: 'mosaic-tile__picture',
          }
        }
        productImageProps={
          media.mosaicItemProductImageProps && {
            ...media.mosaicItemProductImageProps,
            isVideoThumbnail: media.isVideo,
            pictureClassName: 'mosaic-tile__picture',
          }
        }
      />
    </div>
  );
};

export default MediaMosaicItem;
